import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "movie-player-container" }
const _hoisted_2 = { class: "movie-player" }
const _hoisted_3 = { class: "map-area" }
const _hoisted_4 = { class: "control-area ml8" }
const _hoisted_5 = { class: "control-area-toolbar" }
const _hoisted_6 = {
  class: "btn-group btn-group-toggle ws-nowrap",
  style: {"margin-top":"-1px"}
}
const _hoisted_7 = ["checked", "onClick"]
const _hoisted_8 = { class: "controls-container" }
const _hoisted_9 = { class: "row1" }
const _hoisted_10 = { class: "row2" }
const _hoisted_11 = { class: "mt8 metas-container" }
const _hoisted_12 = { class: "mt8 map-elem-infos-container" }
const _hoisted_13 = {
  key: 0,
  class: "ifd-link-area-container"
}

import MoviePlayerControlArea from 'src/components/lib/MoviePlayerControlArea/index.vue';
import MovieMetaInfoArea from 'src/components/lib/MovieMetaInfoArea/index.vue';
import InfraDoctorLinkArea from 'src/components/lib/MoviePlayerCompareMode/InfraDoctorLinkArea.vue';
import MapElemPinCreator from 'src/components/lib/MoviePlayerCompareMode/MapElemPinCreator.vue';
import CompareModeTopBar from 'src/components/lib/MoviePlayerCompareMode/CompareModeTopBar.vue';
import CompareModeVideos from 'src/components/lib/MoviePlayerCompareMode/CompareModeVideos.vue';
import { initGeoItemsMeta } from 'src/models/geoItem';
import { initMovieLayerMeta } from 'src/models';
import type { CompareModeProps, CompareModeEmit } from 'src/models/moviePlayer';
import { computed } from 'vue';
import { useAuth } from 'src/composables/useAuth';
import {
  useMoviePlayerCompareModeState,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeState';
import {
  useMoviePlayerCompareModePlayback,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModePlayback';
import {
  useMoviePlayerCompareModeSeek,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeSeek';
import {
  useMoviePlayerCompareModeCamera,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeCamera';
import {
  useMoviePlayerCompareMode,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareMode';
import {
  useMoviePlayerCompareModeDownload,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeDownload';
import {
  useMoviePlayerCompareModeSensor,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeSensor';
import {
  useMoviePlayerCompareModeTagModal,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeTagModal';
import {
  useMoviePlayerCompareModeMapLinkage,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeMapLinkage';
import {
  useMoviePlayerCompareModeMovieList,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeMovieList';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    movieLists: { default: () => [] },
    movieListId: { default: '' },
    extremeMapEssentials: {},
    parentGeoItemsMeta: { default: initGeoItemsMeta },
    parentMovieLayerMeta: { default: initMovieLayerMeta },
    parentMovieSearch: {}
  },
  emits: ["close", "switch-to-full-mode"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const playerState = useMoviePlayerCompareModeState();
const {
  state,
  enqueueUiTask,
  refExtremeMap,
  refTopBarArea,
  refVideoArea,
  refControlAreaBoth,
  refControlAreaLeft,
  refControlAreaRight,
  refMetaInfoAreaLeft,
  refMetaInfoAreaRight,
} = playerState;

// 分割composableの構築順序: 後段は前段の関数をDIで受け取るため、この順序を変更すると未定義参照になる。
const playback = useMoviePlayerCompareModePlayback(state, { enqueueUiTask });
const seek = useMoviePlayerCompareModeSeek(state, {
  setCurrentMovie: playback.setCurrentMovie, pauseUI: playback.pauseUI, playUI: playback.playUI,
});
const camera = useMoviePlayerCompareModeCamera(state, {
  getVjsForLr: playback.getVjsForLr, getUIPlayState: playback.getUIPlayState,
  pauseUI: playback.pauseUI, playUI: playback.playUI,
});
const download = useMoviePlayerCompareModeDownload(state, { getVjsForVid: playback.getVjsForVid });
const sensor = useMoviePlayerCompareModeSensor(state, { refMetaInfoAreaLeft, refMetaInfoAreaRight });
const tagModal = useMoviePlayerCompareModeTagModal(state, { pauseUI: playback.pauseUI });
const movieList = useMoviePlayerCompareModeMovieList(state, { parentMovieSearch: props.parentMovieSearch });
const map = useMoviePlayerCompareModeMapLinkage(state, {
  refExtremeMap,
  parentGeoItemsMeta: props.parentGeoItemsMeta,
  seekMovie: seek.seekMovie,
  pauseUI: playback.pauseUI,
  playUI: playback.playUI,
  getUIPlayState: playback.getUIPlayState,
  getScreenshotBlob: camera.getScreenshotBlob,
  isCurrentMovieListBothReady: () => movieList.isCurrentMovieListBothReady,
});
const auth = useAuth();
const ifdLinkPrefix = computed(() => auth.user?.settings.ifdLink);

const sub = { playback, seek, map, movieList, tagModal };
const {
  onCurrentMovieListIdChange,
  searchMoviesByDateRange,
  closeMoviePlayer,
  onVideoToolboxAreaClicked,
  shortcutKeyAction,
  switchToFullMode,
  sizes,
  styles,
} = useMoviePlayerCompareMode(props, emit, playerState, sub);

__expose({
  shortcutKeyAction,
});

return (_ctx: any,_cache: any) => {
  const _component_ExtremeMap = _resolveComponent("ExtremeMap")!
  const _component_TagModal = _resolveComponent("TagModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(movieList).isCurrentMovieListBothReady)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "top-bar-area mb8",
            ref_key: "refTopBarArea",
            ref: refTopBarArea
          }, [
            _createVNode(CompareModeTopBar, {
              "left-movie-list-id": _unref(state).left.movieList.listSelection.currentMovieListId,
              "onUpdate:leftMovieListId": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).left.movieList.listSelection.currentMovieListId) = $event)),
              "right-movie-list-id": _unref(state).right.movieList.listSelection.currentMovieListId,
              "onUpdate:rightMovieListId": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).right.movieList.listSelection.currentMovieListId) = $event)),
              "left-movie-lists": _unref(state).left.movieList.listSelection.currentMovieLists,
              "right-movie-lists": _unref(state).right.movieList.listSelection.currentMovieLists,
              "left-base-date": _unref(state).movieSearch.left.baseDate,
              "right-base-date": _unref(state).movieSearch.right.baseDate,
              "selected-camera-position": _unref(state).ui.selectedCameraPosition,
              onChangeMovieListId: _unref(onCurrentMovieListIdChange),
              onSearchByDateRange: _unref(searchMoviesByDateRange),
              onChangeCameraPosition: _unref(camera).changeCameraPosition,
              onSwitchToFullMode: _unref(switchToFullMode),
              onClose: _unref(closeMoviePlayer)
            }, null, 8, ["left-movie-list-id", "right-movie-list-id", "left-movie-lists", "right-movie-lists", "left-base-date", "right-base-date", "selected-camera-position", "onChangeMovieListId", "onSearchByDateRange", "onChangeCameraPosition", "onSwitchToFullMode", "onClose"])
          ], 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "video-area",
        ref_key: "refVideoArea",
        ref: refVideoArea
      }, [
        _createVNode(CompareModeVideos, {
          "video-area-width": _unref(styles).videoAreaWidth,
          "video-area-height": _unref(styles).videoAreaHeight,
          "vid-left": _unref(playback).vid1,
          "vid-right": _unref(playback).vid2,
          "active-vjs-lr-map": _unref(state).ui.activeVjsLrMap,
          "is-current-movie-ready": { left: _unref(state).left.isMovieReady, right: _unref(state).right.isMovieReady },
          "movie-search": _unref(state).movieSearch,
          "is-downloading-screenshot": _unref(download).isDownloadingScreenshot,
          "is-downloading-movie-file": _unref(download).isDownloadingMovieFile,
          onEnterFullscreen: _unref(camera).enterFullScreen,
          onTakeScreenshot: _unref(download).takeScreenshot,
          onDownloadMovieFile: _unref(download).tryDownload,
          onToolboxAreaClick: _unref(onVideoToolboxAreaClicked)
        }, null, 8, ["video-area-width", "video-area-height", "vid-left", "vid-right", "active-vjs-lr-map", "is-current-movie-ready", "movie-search", "is-downloading-screenshot", "is-downloading-movie-file", "onEnterFullscreen", "onTakeScreenshot", "onDownloadMovieFile", "onToolboxAreaClick"])
      ], 512),
      _createElementVNode("div", {
        class: "info-area mt16",
        style: _normalizeStyle({ height: _unref(styles).infoHeight })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ExtremeMap, {
            ref_key: "refExtremeMap",
            ref: refExtremeMap,
            "map-essentials": __props.extremeMapEssentials,
            "disable-movie-layer-interaction": true,
            onClickMap: _unref(map).seekByMapClick,
            onClickItem: _unref(map).onMapItemClicked,
            onAllDeselected: _unref(map).onMapAllDeselected
          }, null, 8, ["map-essentials", "onClickMap", "onClickItem", "onAllDeselected"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-secondary btn-sm mb4",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(map).alignLocationToLeftMovie && _unref(map).alignLocationToLeftMovie(...args)))
              }, [...(_cache[47] || (_cache[47] = [
                _createElementVNode("i", { class: "fas fa-angle-double-left" }, null, -1),
                _createTextVNode(" 走行地点を左に合わせる ", -1)
              ]))])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                  { bulkControl: true, disp: '同時操作' },
                  { bulkControl: false, disp: '個別操作' },
                ], (e, i) => {
                  return _createElementVNode("label", {
                    class: _normalizeClass(["btn btn-info btn-sm", {active: _unref(state).ui.bulkControl === e.bulkControl}]),
                    key: i
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: "options",
                      checked: _unref(state).ui.bulkControl === e.bulkControl,
                      autocomplete: "off",
                      onClick: ($event: any) => (_unref(state).ui.bulkControl = e.bulkControl)
                    }, null, 8, _hoisted_7),
                    _createTextVNode(_toDisplayString(e.disp), 1)
                  ], 2)
                }), 64))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-secondary btn-sm",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(map).alignLocationToRightMovie && _unref(map).alignLocationToRightMovie(...args)))
              }, [...(_cache[48] || (_cache[48] = [
                _createTextVNode(" 走行地点を右に合わせる ", -1),
                _createElementVNode("i", { class: "fas fa-angle-double-right" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createVNode(MoviePlayerControlArea, {
                ref_key: "refControlAreaBoth",
                ref: refControlAreaBoth,
                "control-area-id": "both",
                "view-mode": "other",
                "size-mode": "lg",
                "play-speed": _unref(state).left.playback.currentPlaySpeed,
                "is-play-backward": _unref(state).both.isPlayBackward,
                "is-playing": _unref(state).both.isPlaying,
                onPlay: _cache[4] || (_cache[4] = ($event: any) => (_unref(playback).playUI('both'))),
                onPause: _cache[5] || (_cache[5] = ($event: any) => (_unref(playback).pauseUI('both'))),
                onTickBackward: _cache[6] || (_cache[6] = ($event: any) => (_unref(playback).tickMovieBackward('both'))),
                onTickForward: _cache[7] || (_cache[7] = ($event: any) => (_unref(playback).tickMovieForward('both'))),
                onSetPlaySpeed: _cache[8] || (_cache[8] = ($event: any) => (_unref(playback).setPlaySpeed('both', $event))),
                onSetVolume: _cache[9] || (_cache[9] = ($event: any) => (_unref(playback).setVolume('both', $event))),
                onPlaymodeChange: _cache[10] || (_cache[10] = ($event: any) => (_unref(playback).playModeChange('both', $event)))
              }, null, 8, ["play-speed", "is-play-backward", "is-playing"])
            ], 512), [
              [_vShow, _unref(state).ui.bulkControl]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _createVNode(MoviePlayerControlArea, {
                ref_key: "refControlAreaLeft",
                ref: refControlAreaLeft,
                "control-area-id": "left",
                "view-mode": "comp",
                "size-mode": _unref(sizes).control,
                "play-speed": _unref(state).left.playback.currentPlaySpeed,
                "is-play-backward": _unref(state).left.playback.isPlayBackward,
                "is-playing": _unref(state).left.playback.isPlaying,
                "current-time-disp": _unref(movieList).playerControlCurrentTimeDispLeft,
                "start-time-disp": _unref(state).left.movieList.timeDisp.startTimeDisp,
                "end-time-disp": _unref(state).left.movieList.timeDisp.endTimeDisp,
                "seek-min": _unref(state).left.playback.seek.min,
                "seek-max": _unref(state).left.playback.seek.max,
                "seek-current": _unref(state).left.playback.seek.current,
                "seek-step": _unref(state).left.playback.seek.step,
                onPlay: _cache[11] || (_cache[11] = ($event: any) => (_unref(playback).playMovie('left'))),
                onPause: _cache[12] || (_cache[12] = ($event: any) => (_unref(playback).pauseMovie('left'))),
                onSeekChange: _cache[13] || (_cache[13] = ($event: any) => (_unref(seek).seekBySeekBar('left', $event))),
                onTickBackward: _cache[14] || (_cache[14] = ($event: any) => (_unref(playback).tickMovieBackward('left'))),
                onTickForward: _cache[15] || (_cache[15] = ($event: any) => (_unref(playback).tickMovieForward('left'))),
                onPlayPreviousMovie: _cache[16] || (_cache[16] = ($event: any) => (_unref(playback).playPreviousMovie('left'))),
                onPlayNextMovie: _cache[17] || (_cache[17] = ($event: any) => (_unref(playback).playNextMovie('left'))),
                onSetPlaySpeed: _cache[18] || (_cache[18] = ($event: any) => (_unref(playback).setPlaySpeed('left', $event))),
                onSetVolume: _cache[19] || (_cache[19] = ($event: any) => (_unref(playback).setVolume('left', $event))),
                onPlaymodeChange: _cache[20] || (_cache[20] = ($event: any) => (_unref(playback).playModeChange('left', $event)))
              }, null, 8, ["size-mode", "play-speed", "is-play-backward", "is-playing", "current-time-disp", "start-time-disp", "end-time-disp", "seek-min", "seek-max", "seek-current", "seek-step"]),
              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "spacer m4" }, null, -1)),
              _createVNode(MoviePlayerControlArea, {
                ref_key: "refControlAreaRight",
                ref: refControlAreaRight,
                "control-area-id": "right",
                "view-mode": "comp",
                "size-mode": _unref(sizes).control,
                "play-speed": _unref(state).right.playback.currentPlaySpeed,
                "is-play-backward": _unref(state).right.playback.isPlayBackward,
                "is-playing": _unref(state).right.playback.isPlaying,
                "current-time-disp": _unref(movieList).playerControlCurrentTimeDispRight,
                "start-time-disp": _unref(state).right.movieList.timeDisp.startTimeDisp,
                "end-time-disp": _unref(state).right.movieList.timeDisp.endTimeDisp,
                "seek-min": _unref(state).right.playback.seek.min,
                "seek-max": _unref(state).right.playback.seek.max,
                "seek-current": _unref(state).right.playback.seek.current,
                "seek-step": _unref(state).right.playback.seek.step,
                "corner-label-opacity": 0.5,
                onPlay: _cache[21] || (_cache[21] = ($event: any) => (_unref(playback).playMovie('right'))),
                onPause: _cache[22] || (_cache[22] = ($event: any) => (_unref(playback).pauseMovie('right'))),
                onSeekChange: _cache[23] || (_cache[23] = ($event: any) => (_unref(seek).seekBySeekBar('right', $event))),
                onTickBackward: _cache[24] || (_cache[24] = ($event: any) => (_unref(playback).tickMovieBackward('right'))),
                onTickForward: _cache[25] || (_cache[25] = ($event: any) => (_unref(playback).tickMovieForward('right'))),
                onPlayPreviousMovie: _cache[26] || (_cache[26] = ($event: any) => (_unref(playback).playPreviousMovie('right'))),
                onPlayNextMovie: _cache[27] || (_cache[27] = ($event: any) => (_unref(playback).playNextMovie('right'))),
                onSetPlaySpeed: _cache[28] || (_cache[28] = ($event: any) => (_unref(playback).setPlaySpeed('right', $event))),
                onSetVolume: _cache[29] || (_cache[29] = ($event: any) => (_unref(playback).setVolume('right', $event))),
                onPlaymodeChange: _cache[30] || (_cache[30] = ($event: any) => (_unref(playback).playModeChange('right', $event)))
              }, null, 8, ["size-mode", "play-speed", "is-play-backward", "is-playing", "current-time-disp", "start-time-disp", "end-time-disp", "seek-min", "seek-max", "seek-current", "seek-step"])
            ], 512), [
              [_vShow, !_unref(state).ui.bulkControl]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_unref(movieList).isCurrentMovieListLeftReady)
              ? (_openBlock(), _createBlock(MovieMetaInfoArea, {
                  key: 0,
                  ref_key: "refMetaInfoAreaLeft",
                  ref: refMetaInfoAreaLeft,
                  "view-mode": "comp",
                  movie: _unref(state).left.movieList.current.currentMovie,
                  "movie-geo-index": _unref(state).left.geo.currentMgi,
                  "movie-current-dt": _unref(state).left.geo.currentMovieCurrentDt,
                  "enable-sensor-chart": true,
                  "enable-time-seek": true,
                  "location-disp": _unref(state).left.geo.locationDisp,
                  onTryShowNewSensorChart: _cache[31] || (_cache[31] = ($event: any) => (_unref(sensor).getCurrentMovieListSensorData('left'))),
                  onStartTimeEdit: _cache[32] || (_cache[32] = ($event: any) => (_unref(seek).startTimeTextEdit())),
                  onMoveToTime: _cache[33] || (_cache[33] = ($event: any) => (_unref(seek).seekByTimeText('left', $event))),
                  onEditMovieTags: _cache[34] || (_cache[34] = ($event: any) => (_unref(tagModal).startEditMovieTags('left')))
                }, null, 8, ["movie", "movie-geo-index", "movie-current-dt", "location-disp"]))
              : _createCommentVNode("", true),
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "spacer m4" }, null, -1)),
            (_unref(movieList).isCurrentMovieListRightReady)
              ? (_openBlock(), _createBlock(MovieMetaInfoArea, {
                  key: 1,
                  ref_key: "refMetaInfoAreaRight",
                  ref: refMetaInfoAreaRight,
                  "view-mode": "comp",
                  movie: _unref(state).right.movieList.current.currentMovie,
                  "movie-geo-index": _unref(state).right.geo.currentMgi,
                  "movie-current-dt": _unref(state).right.geo.currentMovieCurrentDt,
                  "enable-sensor-chart": true,
                  "enable-time-seek": true,
                  "corner-label-opacity": 0.5,
                  "location-disp": _unref(state).right.geo.locationDisp,
                  onTryShowNewSensorChart: _cache[35] || (_cache[35] = ($event: any) => (_unref(sensor).getCurrentMovieListSensorData('right'))),
                  onStartTimeEdit: _cache[36] || (_cache[36] = ($event: any) => (_unref(seek).startTimeTextEdit())),
                  onMoveToTime: _cache[37] || (_cache[37] = ($event: any) => (_unref(seek).seekByTimeText('right', $event))),
                  onEditMovieTags: _cache[38] || (_cache[38] = ($event: any) => (_unref(tagModal).startEditMovieTags('right')))
                }, null, 8, ["movie", "movie-geo-index", "movie-current-dt", "location-disp"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(MapElemPinCreator, {
              "map-elem-info": _unref(state).left.geo.mapElemInfo,
              "map-elem-icon-path": _unref(map).mapElemIconPath,
              "visible-geo-item-layers": _unref(map).visibleGeoItemLayers,
              "current-mgi": _unref(state).left.geo.currentMgi,
              "create-failed": _unref(state).left.geo.createMapElemFailed,
              onStartCreate: _cache[39] || (_cache[39] = ($event: any) => (_unref(map).startCreateMapElem('left', _unref(playback).vid1))),
              onCreate: _cache[40] || (_cache[40] = ($event: any) => (_unref(map).createMapElem('left', $event))),
              onCancelEdit: _cache[41] || (_cache[41] = ($event: any) => (_unref(map).clearMapElemInfo('left')))
            }, null, 8, ["map-elem-info", "map-elem-icon-path", "visible-geo-item-layers", "current-mgi", "create-failed"]),
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "spacer m4" }, null, -1)),
            _createVNode(MapElemPinCreator, {
              "map-elem-info": _unref(state).right.geo.mapElemInfo,
              "map-elem-icon-path": _unref(map).mapElemIconPath,
              "visible-geo-item-layers": _unref(map).visibleGeoItemLayers,
              "current-mgi": _unref(state).right.geo.currentMgi,
              "create-failed": _unref(state).right.geo.createMapElemFailed,
              onStartCreate: _cache[42] || (_cache[42] = ($event: any) => (_unref(map).startCreateMapElem('right', _unref(playback).vid2))),
              onCreate: _cache[43] || (_cache[43] = ($event: any) => (_unref(map).createMapElem('right', $event))),
              onCancelEdit: _cache[44] || (_cache[44] = ($event: any) => (_unref(map).clearMapElemInfo('right')))
            }, null, 8, ["map-elem-info", "map-elem-icon-path", "visible-geo-item-layers", "current-mgi", "create-failed"])
          ]),
          (!!ifdLinkPrefix.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(InfraDoctorLinkArea, {
                  "ifd-link-prefix": ifdLinkPrefix.value,
                  "current-movie": _unref(state).left.movieList.current.currentMovie,
                  "current-movie-list": _unref(state).left.movieList.listSelection.currentMovieList,
                  "current-mgi": _unref(state).left.geo.currentMgi,
                  "current-movie-idx": _unref(state).left.movieList.current.currentMovieIdx,
                  "current-mgi-idx": _unref(state).left.geo.currentMgiIdx,
                  "is-first-movie": _unref(state).left.movieList.current.isFirstMovie,
                  "is-last-movie": _unref(state).left.movieList.current.isLastMovie,
                  "is-ready": _unref(state).left.isMovieReady
                }, null, 8, ["ifd-link-prefix", "current-movie", "current-movie-list", "current-mgi", "current-movie-idx", "current-mgi-idx", "is-first-movie", "is-last-movie", "is-ready"]),
                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "spacer m4" }, null, -1)),
                _createVNode(InfraDoctorLinkArea, {
                  "ifd-link-prefix": ifdLinkPrefix.value,
                  "current-movie": _unref(state).right.movieList.current.currentMovie,
                  "current-movie-list": _unref(state).right.movieList.listSelection.currentMovieList,
                  "current-mgi": _unref(state).right.geo.currentMgi,
                  "current-movie-idx": _unref(state).right.movieList.current.currentMovieIdx,
                  "current-mgi-idx": _unref(state).right.geo.currentMgiIdx,
                  "is-first-movie": _unref(state).right.movieList.current.isFirstMovie,
                  "is-last-movie": _unref(state).right.movieList.current.isLastMovie,
                  "is-ready": _unref(state).right.isMovieReady
                }, null, 8, ["ifd-link-prefix", "current-movie", "current-movie-list", "current-mgi", "current-movie-idx", "current-mgi-idx", "is-first-movie", "is-last-movie", "is-ready"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 4)
    ]),
    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "movie-player-backdrop" }, null, -1)),
    (_unref(tagModal).movieTagModal.show)
      ? (_openBlock(), _createBlock(_component_TagModal, {
          key: 0,
          class: "z-index-3000",
          title: "動画タグの編集",
          modelValue: _unref(tagModal).movieTagModal.tags,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_unref(tagModal).movieTagModal.tags) = $event)),
          onClose: _unref(tagModal).updateMovieTags,
          onDismiss: _cache[46] || (_cache[46] = ($event: any) => (_unref(tagModal).movieTagModal.show = false))
        }, null, 8, ["modelValue", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}
}

})